/**
 * Title and subtitle for the viewer's position. A named cell uses that name
 * as the title and the axes as the subtitle. A cell without a name uses the
 * axes as the title.
 * @param input already localized labels; empty strings count as missing
 * @param input.cellLabel name of the cell, when the template gave it one
 * @param input.performanceLabel name of the performance axis
 * @param input.performanceTick label of the performance tick the person sits on
 * @param input.potentialLabel name of the potential axis
 * @param input.potentialTick label of the potential tick the person sits on
 */
export function talentReviewPositionCopy(input: {
	cellLabel?: string;
	performanceLabel?: string;
	performanceTick?: string;
	potentialLabel?: string;
	potentialTick?: string;
}): { title?: string; subtitle?: string } {
	const axis = (label?: string, tick?: string) => {
		const name = label?.trim();
		const value = tick?.trim();

		return name && value ? `${name}: ${value}` : undefined;
	};
	const axes = [
		axis(input.performanceLabel, input.performanceTick),
		axis(input.potentialLabel, input.potentialTick),
	]
		.filter((line): line is string => !!line)
		.join(' • ');
	const cellLabel = input.cellLabel?.trim();

	if (cellLabel) {
		return { title: cellLabel, subtitle: axes || undefined };
	}

	return { title: axes || undefined };
}
